jQuery(document).ready(function($) {
	var isotope_container = $('.magazine-list #magazine_grid');
	isotope_container.imagesLoaded(function(){
		isotope_container.isotope({
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer'
			}
		})
	});

	$('.magazine-gallery .slick').slick({
		dots: true,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: true,
		prevArrow: '<span class="slick-prev hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-right"></span></span>',
	});
	$('.magazine-gallery .slick .slick-dots > li').each(function(){
		$(this).find('button').text( 0 + $(this).find('button').text() );
	});

	$('.magazine-related .articles .slick').slick({
		dots: true,
		nav: false,
		arrows: false,
		adaptiveHeight: false,
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		centerMode: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					centerMode: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.magazine-related .product .slick').slick({
		dots: true,
		nav: false,
		arrows: false,
		adaptiveHeight: false,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	if( isBreakpoint('xs') || isBreakpoint('sm') ){
		$('.magazine-tutorial .slick').slick({
			dots: true,
			nav: false,
			arrows: false,
			adaptiveHeight: true,
			infinite: true,
			fade: true
		});
	}
});
